import React from 'react'
// Node
import moment from 'moment'
import { connect } from 'react-redux'
import { Backdrop, Box, CircularProgress, Grid, Typography } from '@mui/material'
// Components
import Calendar from '../../../../components/common/Calendar'
import MaterialDialog from '../../../../components/material/MaterialDialog'
import BookComponent from '../BookComponent'
// Redux
import { getPrices, addPrice, deletePrice } from '../../../../../redux/reducers/calendar-reducer'
// Own
import { getCalendarEvents } from '../../data/data.calendar_events'

/*
 * Компонент "Стоимость бронирования"
 */

// Экспорт компонента
export const PriceComponent = (props) => {
    // Преобразование пропсов в локальные константы
    const { view, priceList, getPrices, addPrice, deletePrice, loadingPriceComplete, } = props
    
    // Установка объекта с информацией о стоимости
    const [priceFields, setPriceFields] = React.useState({})
    // Установка локального значения открытия диалога удаления
    const [showDeleteModal, setShowDeleteModal] = React.useState(false)
    // Установка объекта с информацией об удалении объекта
    const [deleteInfo, setDeleteInfo] = React.useState({})    
    
    // Хук эффекта
    React.useEffect(() => {        
        // Получить стоимости
        getPrices()        
    }, [getPrices])    
    
    // Получение массива событий календаря 
    const events = getCalendarEvents({ eventList: priceList })
    
    // Клик по событию календаря
    const eventClick = (info) => {         
        if(['admin'].includes(view)) {                
            setDeleteInfo(info)
            setShowDeleteModal(true)
        }
    }
    
    // Клик по пустой ячейке календаря
    const cellClick = (info) => {
        setPriceFields({            
            price_day_of_week: moment(info.startStr).day(), 
            price_date: moment(info.startStr).toDate(),
            price_start_time: moment(info.startStr).toDate(), 
            price_end_time: moment(info.endStr).toDate(), 
        })    
    }        
    
    return(
        <Box sx={{px: 2}}>
            <Typography variant="h6" gutterBottom component="div">
                Lista de precios (en &euro;)
            </Typography>
            {loadingPriceComplete
                ? <Grid container>  
                    <Grid item xs={12}>
                        {['admin'].includes(view)
                            ? <>
                                <BookComponent
                                    bookButtonTitle={'Establecer costo'}
                                    contentTitle={'Detalles de la costo'}
                                    addPrice={addPrice}
                                    view={view}
                                    bookMode={'hall_rental'}
                                    bookFields={priceFields}
                                    snackOpen={false}
                                    snackMessage={''}
                                    snackStatus={'success'}
                                    setSnackOpen={() => {}}
                                    setSnackMessage={() => {}}
                                    setSnackStatus={() => {}}                            
                                />
                                <MaterialDialog title="Eliminar intervalo"
                                    content="Realmente eliminar el espacio?"
                                    showModal={showDeleteModal}
                                    onApplyText={'Sí'}
                                    onCloseText={'No'}
                                    onApply={() => { 
                                        setShowDeleteModal(false)                                                         
                                        deletePrice(deleteInfo?._def?.extendedProps?.book_id)                                                                
                                    }}
                                    onClose={() => { setShowDeleteModal(false) }} 
                                />
                            </>
                            : []
                        }
                        <Calendar
                            view={view}
                            bookMode={'hall_rental'}
                            eventClick={eventClick}
                            cellClick={cellClick}
                            events={events}
                            initialDate={'1970-01-01'}
                            headerToolbar={{left: '', center: '', right: '',}}
                            dayHeaderFormat={{weekday: 'short', omitCommas: true,}}
                        />
                    </Grid>
                </Grid>
                : <Backdrop
                    sx={{ color: '#fff', zIndex: 2 }}
                    open={!loadingPriceComplete}                
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            }
        </Box>    
    )
}

// Маппинг стейта в пропсы компонента
const mapStateToProps = (state) => (    
    {                
        priceList: state.calendarStore?.priceList,
        loadingPriceComplete: state.loadStore.loadingComplete?.price,
    }
)

// Экспорт компонента
export default connect(mapStateToProps, 
    { getPrices, addPrice, deletePrice }
)(PriceComponent)